/**
 * The library's button (DESIGN_SYSTEM.md §5.2): `primary`, `secondary`, `danger`, `ghost` or `link`, at
 * `sm` or `md`, drawn from the theme's roles with hover, focus, press and disabled states. Every v2 action
 * that is a labelled button is one of these; `ActionButton` stays for the live surfaces that draw its
 * older look (§7.2).
 */
import React from "react";

import { ButtonBody } from "./ButtonBody";
import { buttonLook } from "./look";
import type { ButtonVariant } from "./look";

export interface ButtonProps {
  label: string;
  onPress: () => void;
  /** `secondary` by default */
  variant?: ButtonVariant;
  /** `md` by default */
  size?: "sm" | "md";
  /** fill the width it is given */
  fill?: boolean;
  disabled?: boolean;
  /** its action is running: progress shown, presses ignored, not drawn disabled */
  busy?: boolean;
  accessibilityLabel?: string;
  testID?: string;
}

export function Button({ variant, size, fill, ...rest }: ButtonProps) {
  return <ButtonBody look={buttonLook} picks={{ variant, size, fill }} {...rest} />;
}

export type { ButtonVariant };
export default Button;
